import React from "react";
import Spinner from "react-bootstrap/Spinner";

const Loader = () => {
  const barStyle = (width, height = 12) => ({
    width,
    height,
    borderRadius: 999,
    display: "inline-block",
  });

  return (
    <>
      <style>{`
        @keyframes mz-loader-shimmer {
          0% { background-position: -420px 0; }
          100% { background-position: 420px 0; }
        }
      `}</style>
      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "grid",
          placeItems: "center",
          background: "rgba(244, 246, 244, 0.72)",
          backdropFilter: "blur(6px)",
          zIndex: 9999,
          padding: 24,
        }}
      >
        <div
          style={{
            width: "min(520px, 92vw)",
            borderRadius: 18,
            border: "1px solid rgba(226, 232, 226, 0.95)",
            background: "#ffffff",
            boxShadow: "0 18px 50px rgba(15, 23, 42, 0.12)",
            padding: "22px 22px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: 14,
                display: "grid",
                placeItems: "center",
                background: "rgba(26, 92, 48, 0.10)",
                color: "#1a5c30",
                flexShrink: 0,
              }}
            >
              <Spinner animation="border" role="status" size="sm" />
            </div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div
                style={{
                  width: "48%",
                  height: 14,
                  marginBottom: 8,
                  borderRadius: 999,
                  background: "linear-gradient(90deg, #e8ecee 25%, #f4f6f7 50%, #e8ecee 75%)",
                  backgroundSize: "420px 100%",
                  animation: "mz-loader-shimmer 1.4s ease-in-out infinite",
                }}
              />
              <div
                style={{
                  width: "72%",
                  height: 10,
                  borderRadius: 999,
                  background: "linear-gradient(90deg, #e8ecee 25%, #f4f6f7 50%, #e8ecee 75%)",
                  backgroundSize: "420px 100%",
                  animation: "mz-loader-shimmer 1.4s ease-in-out infinite",
                }}
              />
            </div>
          </div>

          <div style={{ display: "grid", gap: 10 }}>
            <span
              style={{
                ...barStyle("100%"),
                background: "linear-gradient(90deg, #e8ecee 25%, #f4f6f7 50%, #e8ecee 75%)",
                backgroundSize: "420px 100%",
                animation: "mz-loader-shimmer 1.4s ease-in-out infinite",
              }}
            />
            <span
              style={{
                ...barStyle("86%"),
                background: "linear-gradient(90deg, #e8ecee 25%, #f4f6f7 50%, #e8ecee 75%)",
                backgroundSize: "420px 100%",
                animation: "mz-loader-shimmer 1.4s ease-in-out infinite",
              }}
            />
            <span
              style={{
                ...barStyle("68%"),
                background: "linear-gradient(90deg, #e8ecee 25%, #f4f6f7 50%, #e8ecee 75%)",
                backgroundSize: "420px 100%",
                animation: "mz-loader-shimmer 1.4s ease-in-out infinite",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Loader;
